// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"600":"8453478e","612":"860361d1","761":"89553908","787":"2ace887d","858":"ce849102"}[chunkId] + ".chunk.js";
};